import * as Printf from "bs-platform/lib/es6/printf.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";

function failwithf(fmt) {
  return Printf.ksprintf(function (s, param) {
    return Pervasives.failwith(s);
  }, fmt);
}

var $$Array =
/* alias */
0;
var Fn =
/* alias */
0;
var Int =
/* alias */
0;
var List =
/* alias */
0;
var $$Option =
/* alias */
0;
var Res =
/* alias */
0;
var $$String =
/* alias */
0;
var Test =
/* alias */
0;
export { $$Array, Fn, Int, List, $$Option, Res, $$String, Test, failwithf };
/* No side effect */